import React from 'react';
import { Redirect } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

function RequireAdmin({ children, redirectTo = '/login' }) {
  const { auth } = useAuth();

  if (!auth.initialized) {
    return null;
  }

  const isAdmin = auth.loggedIn && auth.userData.admin;
  const isCateringUser = !isAdmin && auth.loggedIn && auth.userData.catering_user;
  const isVendorUser = !isAdmin && !isCateringUser && auth.loggedIn;

  let redirectLink = redirectTo;
  if (isCateringUser) {
    redirectLink = '/catering/dashboard';
  } else if (isVendorUser) {
    const { trucks } = auth.userData;
    const hasTruck = trucks && trucks.length > 0;
    redirectLink = hasTruck ? ('/vendor/truck/' + trucks[0].slug) : '/vendor';
  }

  return isAdmin ? children : <Redirect to={redirectLink}/>;
}

export default RequireAdmin;
